import script from "./WebhookDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./WebhookDialog.vue?vue&type=script&setup=true&lang=js"

import "./WebhookDialog.vue?vue&type=style&index=0&id=3fddc68f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fddc68f"]])

export default __exports__